import { render, staticRenderFns } from "./ListAgents.vue?vue&type=template&id=8af3610c"
import script from "./ListAgents.vue?vue&type=script&lang=js"
export * from "./ListAgents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports